<div
  id="account-table-container"
  class="matp-table-container tw-max-h-[calc(100vh_-_265px)]"
>
  <div class="matp-table-actions-area">
    <div class="matp-table-actions">
      <button
        mat-raised-button
        id="filter-clear-btn"
        class="tw-mr-2"
        (click)="clearFilters()"
      >
        <mat-icon>restart_alt</mat-icon>
        <span>クリア</span>
      </button>
      <button
        mat-raised-button
        id="add-btn"
        color="primary"
        class="tw-mr-2"
        (click)="created.emit()"
        [disabled]="readonly"
      >
        <mat-icon>add</mat-icon>
        <span>
          {{ roleName }}
          新規登録</span
        >
      </button>
      <button
        mat-raised-button
        id="delete-all-btn"
        color="warn"
        class="tw-mr-2"
        (click)="deleteAll()"
        [disabled]="readonly || !selection.hasValue()"
      >
        <mat-icon>delete</mat-icon>
        <span>{{ roleName }} 一括削除</span>
      </button>
    </div>
  </div>

  <div class="matp-table-area">
    <table
      id="account-table"
      class="matp-table"
      mat-table
      matSort
      [matSortActive]="initSortState.active"
      [matSortDirection]="initSortState.direction"
      [dataSource]="dataSource"
    >
      <!-- チェックボックス -->
      <ng-container matColumnDef="checkbox">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="matp-table-header-middle !tw-min-w-min"
        >
          <mat-checkbox
            name="selectAll"
            color="primary"
            (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [disabled]="readonly"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            name="select"
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(element) : null"
            [checked]="selection.isSelected(element)"
            [disabled]="readonly"
          ></mat-checkbox>
        </td>
      </ng-container>

      <!-- テナント -->
      <ng-container matColumnDef="tenant">
        <th mat-header-cell *matHeaderCellDef>
          <div class="matp-table-header-title">
            <span mat-sort-header>テナント</span>
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              [(ngModel)]="selectedTenant"
              name="tenant"
              panelClass="matp-table-select-panel"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              @for (tenant of tenantList; track $index) {
                <mat-option [value]="tenant.tenantName">{{
                  tenant.tenantName
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </th>
        <td mat-cell name="tenant" *matCellDef="let element">
          {{ element.tenant.tenantName }}
        </td>
      </ng-container>

      <!-- ユーザー名 -->
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef>
          <div class="matp-table-header-title">
            <span mat-sort-header>ユーザー名</span>
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="userName"
              type="text"
              [(ngModel)]="userNameKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="username-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearUserNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="userName" *matCellDef="let element">
          {{ element.familyName }}&nbsp;{{ element.givenName }}
        </td>
      </ng-container>

      <!-- メールアドレス -->
      <ng-container matColumnDef="userId">
        <th mat-header-cell *matHeaderCellDef>
          <div class="matp-table-header-title">
            <span mat-sort-header>メールアドレス</span>
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="email"
              matInput
              appAutocompleteOff
              type="text"
              [(ngModel)]="emailKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="email-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearEmailFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td name="email" mat-cell *matCellDef="let element">
          {{ element.userId }}
        </td>
      </ng-container>

      <!-- メールアドレス認証ステータス -->
      <ng-container matColumnDef="emailStatus">
        <th mat-header-cell *matHeaderCellDef>
          <div class="matp-table-header-title tw-text-nowrap">
            <span mat-sort-header>メールアドレス認証ステータス</span>
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              name="emailStatus"
              panelClass="matp-table-select-panel"
              [(ngModel)]="selectedEmailStatus"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              <mat-option [value]="false">未認証</mat-option>
              <mat-option [value]="true">認証済</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td mat-cell name="emailStatus" *matCellDef="let element">
          {{ element.emailStatus ? "認証済" : "未認証" }}
        </td>
      </ng-container>

      <!-- 2要素認証設定 -->
      <ng-container matColumnDef="mfaRequired">
        <th mat-header-cell *matHeaderCellDef>
          <div class="matp-table-header-title">
            <span mat-sort-header>2要素認証設定</span>
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              name="mfaRequired"
              panelClass="matp-table-select-panel"
              [(ngModel)]="selectedMfaRequired"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              <mat-option [value]="true">必須</mat-option>
              <mat-option [value]="false">任意</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td mat-cell name="mfaRequired" *matCellDef="let element">
          {{ element.mfaRequired ? "必須" : "任意" }}
        </td>
      </ng-container>

      <!-- 2要素認証ステータス -->
      <ng-container matColumnDef="mfaStatus">
        <th mat-header-cell *matHeaderCellDef>
          <div class="matp-table-header-title tw-text-nowrap">
            <span mat-sort-header>2要素認証ステータス</span>
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              name="mfaStatus"
              panelClass="matp-table-select-panel"
              [(ngModel)]="selectedMfaStatus"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              <mat-option [value]="false">未認証</mat-option>
              <mat-option [value]="true">認証済</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td mat-cell name="mfaStatus" *matCellDef="let element">
          {{ element.mfaStatus ? "認証済" : "未認証" }}
        </td>
      </ng-container>

      <!-- 設定権限 -->
      <ng-container matColumnDef="configurable">
        <th mat-header-cell *matHeaderCellDef>
          <div class="matp-table-header-title">
            <span mat-sort-header>設定権限</span>
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              name="configurable"
              [(ngModel)]="selectedConfigurable"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              <mat-option [value]="true">あり</mat-option>
              <mat-option [value]="false">なし</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td mat-cell name="configurable" *matCellDef="let element">
          {{ element.configurable ? "あり" : "なし" }}
        </td>
      </ng-container>

      <!-- 閲覧可能タグ -->
      <ng-container matColumnDef="deviceTagList">
        <th mat-header-cell *matHeaderCellDef>
          <div class="matp-table-header-title">
            <span mat-sort-header>閲覧可能タグ</span>
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="deviceTag"
              matInput
              appAutocompleteOff
              type="text"
              [(ngModel)]="deviceTagKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="devicetag-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearDeviceTagFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="deviceTagId" *matCellDef="let element">
          @for (
            deviceTag of getValidDeviceTags(
              deviceTagList,
              element.deviceTagList
            );
            track deviceTag
          ) {
            <div class="tw-text-xs">
              <mat-card
                class="tw-m-2 tw-p-1 !tw-inline-block"
                [ngStyle]="tagStyle(deviceTag.color)"
                >{{ deviceTag.tagName }}</mat-card
              >
            </div>
          }
        </td>
      </ng-container>

      <!-- 最終ログイン日時 -->
      <ng-container matColumnDef="lastLoginAt">
        <th mat-header-cell *matHeaderCellDef>
          <div class="matp-table-header-title tw-text-nowrap">
            <span mat-sort-header>最終ログイン日時</span>
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="lastLoginAt"
              matInput
              appAutocompleteOff
              type="text"
              [(ngModel)]="lastLoginAtKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="lastloginat-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearLastLoginAtFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="lastLoginAt" *matCellDef="let element">
          {{ element.lastLoginAt | date: "yyyy/MM/dd HH:mm:ss" }}
        </td>
      </ng-container>

      <!-- 操作 -->
      <ng-container matColumnDef="operation">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-32 tw-max-w-32">
          <div class="matp-table-header-title">操作</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-stroked-button
            id="edit-btn"
            color="primary"
            (click)="updated.emit(element)"
            [disabled]="readonly"
          >
            <mat-icon>edit</mat-icon>
            <span>編集</span>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    id="account-table-paginator"
    [length]="dataSource.filteredData.length"
    hidePageSize
    showFirstLastButtons
  >
  </mat-paginator>
</div>
